
export const getUser = () => {
  const user = localStorage.getItem("qqc_userData");
  return user ? JSON.parse(user) : null;
};

export const getToken = () => {
  return localStorage.getItem("qqc_userToken");
};

export const isAuthenticated = () => {
  return !!getToken();
};

export const logout = () => {
  localStorage.removeItem("qqc_userToken");
  localStorage.removeItem("qqc_userData");
};
